import { render, staticRenderFns } from "./ProjectDescription.vue?vue&type=template&id=a0e2bb94&scoped=true"
import script from "./ProjectDescription.vue?vue&type=script&lang=js"
export * from "./ProjectDescription.vue?vue&type=script&lang=js"
import style0 from "./ProjectDescription.vue?vue&type=style&index=0&id=a0e2bb94&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0e2bb94",
  null
  
)

export default component.exports